import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsDataManagerGettingStartedRoute: InvariantJiraRoute = {
	name: 'assets-data-manager-getting-started',
	path: '/jira/assets/data-manager/getting-started',
	exact: true,
};
